import type { IExtractRouteParamMap, IRouteTranslation } from "../../types";
import { createBreadcrumbObject, createPaths } from "../../utils";

// Base route constant
const baseRoute = `/`;

// * Route configuration object for home-related paths.
// ! This object is `readonly` to ensure route parameters are extracted properly.
export const homeRoutesObj = {
  home: baseRoute,
} as const;

// ! these are breadcrumbs translation not page title
const homeRouteTranslation: IRouteTranslation<typeof homeRoutesObj> = {
  home: "mainPage",
};

// * Extracts the route parameters for the home route configuration.
export type IHomeRouteParams = IExtractRouteParamMap<typeof homeRoutesObj>;

// * Path functions for the home routes.
export const homePath = createPaths<typeof homeRoutesObj, IHomeRouteParams>(
  homeRoutesObj,
);

// * Breadcrumbs {translation and route} for the faculty routes
export const homeBreadcrumbs = createBreadcrumbObject<typeof homeRoutesObj>(
  homeRoutesObj,
  homeRouteTranslation,
);
